import React, { useState } from 'react';
import { Grid, Typography, Button, Box, IconButton } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DocumentUploadModal from './DocumentUploadModal'; // Импортируем нашу модалку

const ProjectSpecifications = ({ project, canEdit, uploadMutation, updateProjectMutation }) => {

	// console.log('ProjectSpecifications project',project);

  // Стейт для управления видимостью модального окна
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Обработчик, который мы передадим в модальное окно
  const handleFileUpload = async (file, finalName) => {
    const formData = new FormData();
    formData.append('image', file); // Убедись, что на бэке multer принимает 'image' или поменяй на 'file'

    // 1. Загружаем физический файл на сервер
    const uploadRes = await uploadMutation(formData).unwrap();
    
    // 2. Обновляем массив specificationFiles в БД
    if (uploadRes?.image) {
		await updateProjectMutation({ 
				projectId: project._id, 
				name: finalName, 
				url: uploadRes.image 
			}).unwrap();
    }
  };

  const handleDelete = async (fileUrlToDelete) => {
    if (!window.confirm('Вы уверены, что хотите удалить этот документ?')) return;
    const updatedFiles = (project.specificationFiles || []).filter(f => f.url !== fileUrlToDelete);
    
    try {
      await updateProjectMutation({ _id: project._id, specificationFiles: updatedFiles }).unwrap();
    } catch (error) {
      console.error("Ошибка удаления:", error);
    }
  };

  return (
    <>
      <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Проектная документация</Typography>
          
          {canEdit && (
            <Button 
              variant="contained" 
              startIcon={<CloudUploadIcon />} 
              onClick={() => setIsModalOpen(true)} // Открываем модалку
            >
              Загрузить документ
            </Button>
          )}
        </Grid>
        
        {(project.specificationFiles || []).length === 0 ? (
           <Grid item xs={12}>
             <Typography variant="body2" color="text.secondary">Документы пока не загружены.</Typography>
           </Grid>
        ) : (
          (project.specificationFiles || []).map((file, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                <PictureAsPdfIcon color="error" />
                <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                  <Typography variant="subtitle2" sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {file.name} {/* Выводим тип: "Договор", "Смета" и т.д. */}
                  </Typography>
                </Box>
                <Button size="small" href={file.url} target="_blank" rel="noopener">
                  Открыть
                </Button>
                {canEdit && (
                  <IconButton size="small" color="error" onClick={() => handleDelete(file.url)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            </Grid>
          ))
        )}
      </Grid>

      {/* Встраиваем модальное окно */}
      <DocumentUploadModal 
        open={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onUpload={handleFileUpload} 
      />
    </>
  );
};

export default ProjectSpecifications;